/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { LocaleId } from '../../data/translation/i18n';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../data/store.typings';
import { changeLocale } from '../../data/actions/userActions';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        select: {
            '&:before': {
                border: 'none',
            },
            '&:after': {
                border: 'none',
            },
            margin: theme.spacing(1),
        },
        countryFlag: {
            width: 19,
            height: 13,
            borderRadius: 2,
            margin: theme.spacing(0, 1),
        },
    }),
);

export const SwitchLocalesSelect = () => {
    const locale = useSelector(getLocale);
    const dispatch = useDispatch();
    const classes = useStyles();

    return (
        <Select
            data-testid="localesSelect"
            variant="standard"
            className={classes.select}
            value={locale}
            onChange={(e) => dispatch(changeLocale(e.target.value as LocaleId))}
        >
            {LOCALE_SELECT_ITEMS.map((item) => {
                return (
                    <MenuItem key={item.id} value={item.id}>
                        <img className={classes.countryFlag} src={item.flagUrl} alt="Country flag" />
                        {item.label}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

const getLocale = (state: RootState) => {
    return state.userReducer.localeId;
};

const LOCALE_SELECT_ITEMS = [
    {
        id: LocaleId.Az,
        label: 'Azərbaycanca',
        flagUrl: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/az.svg',
    },
    {
        id: LocaleId.Ru,
        label: 'Русский',
        flagUrl: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/ru.svg',
    },
    {
        id: LocaleId.En,
        label: 'English',
        flagUrl: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/gb.svg',
    },
];
